import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.addDocument`,
    defaultMessage: 'Add Document',
  },
  remove: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.remove`,
    defaultMessage: 'Remove',
  },
  removeDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.removeDocument`,
    defaultMessage: 'Remove Document',
  },
  removeDocumentConfirmationText: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.removeDocumentConfirmationText`,
    defaultMessage: `Are you sure you want to remove the "{title}" document?`,
  },
  documents: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.documents`,
    defaultMessage: 'Documents',
  },
  // AXHE-4106: offer letter templates share this list with legacy documents, so
  // the row has to say which kind it is — the two are configured in different
  // places and only one opens the offer letter editor.
  //
  // AXHE-4226 added the behaviour, because saying which KIND a row is turned out
  // not to answer the question an admin actually has about it: the documents
  // around it send when the applicant lands, and this one does not — it waits for
  // a recruiter to open Send Offer and enter the values. The confusion is
  // per-document, so it is answered on the row rather than only in the sentence
  // above the list.
  //
  // "Signature template", not "Offer letter template" (AXHE-4400). Both ids in
  // this file keep the old noun deliberately — see the rule and the
  // rename-don't-re-mint reasoning in OfferLetterTemplates/messages.ts.
  offerLetterBadge: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.offerLetterBadge`,
    defaultMessage: 'Signature template, sent by a recruiter',
  },
  // BaseStageSerializer#offer_letter_templates_for_stage deliberately surfaces
  // an assigned-but-INACTIVE template so a recruiter can clear a stale
  // assignment (AXHE-3836). Rendering it identically to an active one meant the
  // detach action worked but the reason to use it was invisible — the recruiter
  // could not tell why the row was there (rantler, PR #2996).
  //
  // Deliberately does NOT carry the "sent by a recruiter" behaviour the active
  // badge gained in AXHE-4226: a deactivated assignment is not sent by anyone,
  // and the only thing to say about the row is that it should be cleared.
  offerLetterInactiveBadge: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.offerLetterInactiveBadge`,
    defaultMessage: 'Signature template (inactive)',
  },
  noDocuments: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.noDocuments`,
    defaultMessage: 'No documents added yet.',
  },
  noDocumentsError: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.noDocumentsError`,
    defaultMessage:
      'At least one document is required for this stage to work, please add.',
  },
  templateTitleMissing: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.templateTitleMissing`,
    defaultMessage: 'Template title missing',
  },
  uploadDocumentTemplates: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.uploadDocumentTemplates`,
    defaultMessage:
      'Upload document templates in <link>company settings</link> to use in this stage.',
  },
});
